import templateStr from 'text!./filter.html';
import _ from 'underscore';
import assert from 'assert';
/**
 * Filter directive
 *
 * Accepts a loadByOffset method with signature (offsetStart, offsetEnd) -> promise
 * loadByOffset should resolve with pageListData, actual data that would be shown
 *  {number}    pageListData.maxNumberOfResults     Maximum possible number of results for the given query
 *
 * Returned data will be available as pageListData in the transcluded scope
 *
 * @returns {Object}
 */
export default ['SearchService', '$q', function (SearchService, $q) {
    return {
        restrict: 'E',
        template: templateStr,
        transclude: true,
        scope: {
            loadByOffset: '&',
            pageSize: '@',
            pageTitle: '@',
            showWholeList: '=',
            tableTitle: '@',
            filterType: '@',
            placeHolderName: '@'
        },
        link: function link($scope, $element) {

            //Added for pagination to take effect after custom filter in landing page quotes_MSF
            $scope.$on('customFilterSelected', function () {
                initPageData();
                loadInitData();
            });

            var pageSize = parseInt($scope.pageSize) || 10;
            $scope.loading = false;
            $scope.searchRequest = {
                searchParam: ''
            };

            initPageData();

            function initPageData() {

                $scope.pageData = {
                    displayStart: 1,
                    displayEnd: pageSize
                };
            }

            function loadInitData() {
                loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1, undefined);
            }

            $scope.reload = loadInitData;

            $scope.filterAccounts = function (filterParam) {
                if (filterParam != undefined && filterParam.length >= 5) {
                    $scope.loading = true;
                    $scope.filterParamLengthValid = true;
                    $scope.searchRequest.searchParam = filterParam;
                    var filterResults = SearchService.search($scope.searchRequest);
                    $scope.filterResultsPromise = filterResults;

                    $q.when(filterResults, function (filterResult) {
                        $scope.pageListData.items = getAccountSummaries(filterResult.accounts);
                        if (!_.isUndefined($element.scope())) {
                            $element.scope().pageListData.items = getAccountSummaries(filterResult.accounts);
                        }
                        $scope.filterCompleted = true;
                        $scope.loading = false;
                    }, function (error) {
                        if (error.baseError.data.error) {
                            if (error.baseError.data.error.data.appErrorCode !== 609) {
                                ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                            }
                        } else {
                            ModalService.showError('gateway.views.modal.Error', 'gateway.views.search.Search Error');
                        }
                        $scope.filterCompleted = true;
                        $scope.loading = false;
                    });
                } else {
                    $scope.searchRequest.searchParam = filterParam;
                    $scope.filterResultsPromise = [];
                    $scope.filterCompleted = true;
                    $scope.filterParamLengthValid = false;
                }
            };

            $scope.filterCondition = function (filterParam) {
                if (filterParam.length != 0 && filterParam.length < 5) {
                    $scope.showErr = true;
                } else {
                    $scope.showErr = false;
                }
                if ($scope.filterType == 'pendingCancel') {
                    if (filterParam != undefined && filterParam.length >= 5) {
                        loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1, filterParam);
                    } else if (filterParam == undefined || filterParam == '') {
                        loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1, '');
                    }
                } else {
                    if (filterParam != undefined && filterParam.length >= 5) {
                        $scope.filterAccounts(filterParam);
                    } else if (filterParam == undefined || filterParam == '') {
                        loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1, '');
                    }
                }
            };

            function getAccountSummaries(accounts) {
                var accountSummaries = [];
                if (angular.isDefined(accounts) && accounts.length > 0) {
                    accounts.forEach(function (account) {
                        var accountSummary = {
                            account: account.accountHolder,
                            accountNumber: account.accountNumber,
                            policyCount: account.policyCount,
                            createdDate: account.accountCreatedDate,
                            address: account.accountHolderAddress,
                            isCommercial: account.isCommercialAccount,
                            isPersonal: account.isPersonalAccount,
                            createdByMe: account.createdByMe
                        };

                        accountSummaries.push(accountSummary);
                    });
                }

                return accountSummaries;
            }

            function loadData(offsetStart, offsetEnd, filterParam) {
                $scope.error = false;
                $scope.loading = true;
                var loadByOffset = $scope.loadByOffset()(offsetStart, offsetEnd, filterParam);
                if (angular.isUndefined(loadByOffset)) {
                    return;
                }
                loadByOffset.then(function (data) {
                    if (_.isUndefined(data)) {
                        $scope.loading = false;
                    } else {
                        if (!_.isUndefined(data)) {
                            //Avoiding a data is undefined error during pagination.
                            $scope.pageListData = data;
                            //Taking care of pageList setting error in the background.
                            if (!_.isUndefined($element.scope())) {
                                $element.scope().pageListData = data;
                            }
                            $scope.loading = false;
                        }
                    }
                }).catch(function () {
                    $scope.error = true;
                });
            }

            var update = function update() {
                initPageData();
                loadInitData();
            };

            $scope.$watch('loadByOffset()', update);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/gateway/filterDirective/Filter.js
// module id = 1290
// module chunks = 0